export default __webpack_public_path__ + "static/media/WrecklessAbandon-Master2.b039ba0f.mp3";